import React, { useState } from 'react';
import { API_ENDPOINTS } from '../../config/apiRouting';

const PaymentTest: React.FC = () => {
  const [healthResult, setHealthResult] = useState<string>('');
  const [createResult, setCreateResult] = useState<string>('');
  const [validateResult, setValidateResult] = useState<string>('');
  const [paymentId, setPaymentId] = useState<string>('');
  const [token, setToken] = useState<string>('');

  const testHealth = async () => {
    setHealthResult('Testing...');
    try {
      const response = await fetch(API_ENDPOINTS.paymentHealth());
      const data = await response.json();
      setHealthResult(JSON.stringify(data, null, 2));
    } catch (error: any) {
      setHealthResult(`Error: ${error.message}`);
    }
  };

  const createPaymentLink = async () => {
    setCreateResult('Creating payment link...');
    try {
      const response = await fetch(API_ENDPOINTS.paymentLinks(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          checkId: `test-check-${Date.now()}`,
          storeId: 'TEST001',
          totalAmount: 25.50,
          serverName: 'Test Server',
          tableNumber: 'Table 5',
          items: { 'Test Item': 25.50 }
        })
      });

      const data = await response.json();
      if (response.ok) {
        setCreateResult(JSON.stringify(data, null, 2));
        // Auto-fill the validation form
        setPaymentId(data.paymentId);
        const tokenMatch = data.paymentUrl.match(/token=([^&]+)/);
        if (tokenMatch) {
          setToken(tokenMatch[1]);
        }
      } else {
        setCreateResult(`Error: ${data.error}`);
      }
    } catch (error: any) {
      setCreateResult(`Error: ${error.message}`);
    }
  };

  const validatePaymentLink = async () => {
    if (!paymentId || !token) {
      setValidateResult('Please enter both Payment ID and Token');
      return;
    }

    setValidateResult('Validating...');
    try {
      const url = `${API_ENDPOINTS.paymentLink(paymentId)}/validate?token=${token}`;
      console.log('Fetching:', url);

      const response = await fetch(url);
      const data = await response.json();

      if (response.ok) {
        setValidateResult(JSON.stringify(data, null, 2));
      } else {
        setValidateResult(`Validation failed: ${data.error}`);
      }
    } catch (error: any) {
      setValidateResult(`Error: ${error.message}`);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Payment API Test</h1>

      <div style={{ margin: '20px 0', padding: '20px', border: '1px solid #ddd', borderRadius: '5px' }}>
        <h2>Test 1: API Health Check</h2>
        <button onClick={testHealth}>Test Health Endpoint</button>
        <pre style={{ background: '#f5f5f5', padding: '10px', marginTop: '10px' }}>
          {healthResult}
        </pre>
      </div>

      <div style={{ margin: '20px 0', padding: '20px', border: '1px solid #ddd', borderRadius: '5px' }}>
        <h2>Test 2: Create Payment Link</h2>
        <button onClick={createPaymentLink}>Create Payment Link</button>
        <pre style={{ background: '#f5f5f5', padding: '10px', marginTop: '10px' }}>
          {createResult}
        </pre>
      </div>

      <div style={{ margin: '20px 0', padding: '20px', border: '1px solid #ddd', borderRadius: '5px' }}>
        <h2>Test 3: Validate Payment Link</h2>
        <p>
          Payment ID:{' '}
          <input
            type="text"
            value={paymentId}
            onChange={(e) => setPaymentId(e.target.value)}
            placeholder="PAY-xxx"
            style={{ width: '300px' }}
          />
        </p>
        <p>
          Token:{' '}
          <input
            type="text"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder="security token"
            style={{ width: '500px' }}
          />
        </p>
        <button onClick={validatePaymentLink}>Validate Payment Link</button>
        <pre style={{ background: '#f5f5f5', padding: '10px', marginTop: '10px' }}>
          {validateResult}
        </pre>
      </div>

      <div style={{ marginTop: '40px', padding: '20px', background: '#f0f0f0', borderRadius: '5px' }}>
        <h3>Debug Information</h3>
        <p>Payment API URL: {API_ENDPOINTS.paymentLinks()}</p>
        <p>Current URL: {window.location.href}</p>
        <p>User Agent: {navigator.userAgent}</p>
      </div>
    </div>
  );
};

export default PaymentTest;